import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2, ViewChild} from '@angular/core';

@Component({
  selector: 'app-bottom-bar',
  templateUrl: './bottom-bar.component.html',
  styleUrls: ['./bottom-bar.component.scss']
})
export class BottomBarComponent implements OnInit {
  @Input() negativeRoute: string = '';
  @Input() negativeLabel: string = '';
  @Input() negativeDisabled: boolean = true;
  @Input() positiveLabel: string = '';
  @Input() positiveDisabled: boolean = true;
  @Output() negativeAction = new EventEmitter();
  @Output() positiveAction = new EventEmitter();

  @ViewChild('bFixContainer') buttonContainer: any;

  private widthObserver: ResizeObserver | undefined;
  private mainContentContainer: any;
  private setupLimit = 3;

  constructor(private renderer: Renderer2) {
  }

  ngOnInit(): void {
    this.setupLimit = 3;
  }

  ngOnDestroy() {
    if (this.widthObserver) {
      this.widthObserver.unobserve(this.mainContentContainer);
      this.widthObserver.disconnect();
    }
  }

  ngAfterViewInit(): void {
    setTimeout(this.setupObserver.bind(this), 100);
  }

  setupObserver() {
    this.mainContentContainer = document.getElementsByClassName('mainContentContainer')[0];
    this.widthObserver = new ResizeObserver(entries => {
      const width = entries[0].contentRect.width;
      this.renderer.setStyle(this.buttonContainer.nativeElement, 'width', width + 'px');
      this.renderer.setStyle(this.buttonContainer.nativeElement, 'left', entries[0].target.getBoundingClientRect().left + 'px');
      this.renderer.setStyle(this.buttonContainer.nativeElement, 'opacity', '1');
    });

    if (this.mainContentContainer) {
      this.widthObserver.observe(this.mainContentContainer);
    } else if (this.setupLimit > 0) {
      this.setupLimit--;
      setTimeout(this.setupObserver.bind(this), 100);
    }
  }
}
